<form [formGroup]="formGroup()" novalidate>
  @for (sectionId of orderSectionIds(); track $index) {
    <div class="section">
      <lib-section
        [sectionFormGroup]="sections()[sectionId]"
        [isCollapsed]="!sectionService.getExpandedById(sectionId)"
        [showAllFollowUps]="showAllFollowUps()"
        [hideValidation]="hideValidation()"
        [previewMode]="previewMode()"
      >
      </lib-section>
    </div>
  }
</form>
